<template>
  <footer class="footer">
    <div class="container">
      <!-- <span>Developed by</span> <a href="https://github.com/kouts" target="_blank" rel="noopener">@kouts</a> -->
    </div>
  </footer>
</template>
